// React Imports
import * as React from 'react';
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

// App Imports
import SeriesContractStatsGrid from "./SeriesContractStats";
import SeasonContractStatsGrid from "./SeasonContractStats";
import EpisodeContractStatsGrid from "./EpisodeContractStats";
import {changeContractStatsControls} from "./contractStatsControlsSlice";
import {changeContractStats} from "./contractStatsSlice";
import GuildContractStatsGrid from "./GuildContractStats";
import MarketGroupContractStatsGrid from "./MarketGroupContractStats";
import ReleaseMarketContractStatsGrid from "./ReleaseMarketContractStats";


// main function
export default function WorkStatsFrame(props) {


    const selectorSeriesId = useSelector((state) => state.contractStatsSlc.value.seriesId);
    const selectorSeasonId = useSelector((state) => state.contractStatsSlc.value.seasonId);
    const selectorProductId = useSelector((state) => state.contractStatsSlc.value.productId);
    const selectorSeriesTitle = useSelector((state) => state.contractStatsSlc.value.seriesTitle);
    const selectorSeasonName = useSelector((state) => state.contractStatsSlc.value.seasonName);
    const selectorEpisodeName = useSelector((state) => state.contractStatsSlc.value.episodeName);
    const selectorPhotoStartDate = useSelector((state) => state.contractStatsSlc.value.photoStartDate);
    const selectorGridDisplay = useSelector((state) => state.contractStatsControlsSlc.value.gridDisplay);
    const dispatchData = useDispatch();

    const handleGridDisplayAll = (level)  => {dispatchData(changeContractStatsControls({gridDisplay: level}));
        dispatchData(changeContractStats({seriesId: null, seriesTitle: null,seasonId: null, seasonName: null,
        productId: null, episodeName: null, photoStartDate: null}))};

    const handleGridDisplaySeries = (level)  => {dispatchData(changeContractStatsControls({gridDisplay: level}));
        dispatchData(changeContractStats({seriesId: selectorSeriesId, seriesTitle: selectorSeriesTitle, seasonId: null, seasonName: null,
            productId: null, episodeName: null, photoStartDate: null}))};


    const handleGridDisplaySeason = (level)  => {dispatchData(changeContractStatsControls({gridDisplay: level}));
        dispatchData(changeContractStats({seriesId: selectorSeriesId, seriesTitle: selectorSeriesTitle, seasonId: selectorSeasonId, seasonName: selectorSeasonName,
            productId: null, episodeName: null, photoStartDate: null}))};


    return (


        <div>
            {/*{useSelector((state) => state.contractStatsControlsSlc.value.gridDisplay)}*/}
            { (selectorGridDisplay === "SeriesFullScreen" || selectorGridDisplay === "SeasonFullScreen" || selectorGridDisplay === "EpisodeFullScreen")  &&
            <Stack direction={"row"} spacing={2}>
                <Box>
                <h3 style={{cursor: 'pointer'}} onClick={() => handleGridDisplayAll("SeriesFullScreen")}>  All Series</h3>
                </Box>
                    <Box>
                {selectorSeriesId !== null && <h3>{' >'}</h3>}
                    </Box>
                        <Box>
                    <h3 style={{cursor: 'pointer'}}
                     onClick={() => handleGridDisplaySeries("SeasonFullScreen")}> {selectorSeriesTitle}</h3>
                        </Box>
                            <Box>
                        {selectorSeasonId !== null && <h3>{' >'}</h3>}
                            </Box>
                                <Box>
                        <h3 style={{cursor: 'pointer'}}
                            onClick={() => handleGridDisplaySeason("EpisodeFullScreen")}
                        > {selectorSeasonName}</h3>
                                </Box>
                <Box>
                    {selectorProductId !== null && <h3>{' >'}</h3>}
                </Box>
                <Box>
                    {selectorProductId !== null && <h3 style={{cursor: 'pointer'}}
                    > {selectorEpisodeName} ( {selectorProductId}, {selectorPhotoStartDate} )</h3>}
                </Box>
            </Stack>}
            <div>
                {selectorGridDisplay === "MarketGroupContractStats" && <MarketGroupContractStatsGrid/>}
                {selectorGridDisplay === "ReleaseMarketFullScreen" && <ReleaseMarketContractStatsGrid/>}

                {/*{selectorGridDisplay === "SeriesFullScreen" && <StandAloneContractStatsGrid/>}*/}
                {/*{selectorGridDisplay === "SeriesFullScreen" && <ReleaseMarketContractStatsGrid/>}*/}
                {/*{selectorGridDisplay === "SeriesFullScreen" && <MarketGroupContractStatsGrid/>}*/}
                {selectorGridDisplay === "SeriesFullScreen" && <SeriesContractStatsGrid/>}
                {selectorGridDisplay === "SeasonFullScreen" && <SeasonContractStatsGrid/>}
                {selectorGridDisplay === "EpisodeFullScreen" && <EpisodeContractStatsGrid/>}
                {selectorGridDisplay === "GuildFullScreen" && <GuildContractStatsGrid/>}
            </div>
        </div>

    );

}
